import React, { Component } from "react";
import {
    Modal,
    Header,
    Container,
    Message
} from "semantic-ui-react";
import Dropzone from 'react-dropzone-uploader';

class ModalUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadsComplete: false,
            error: "",
            open: props.openModal,
            status: ""
        };
    }
    componentDidUpdate = async prevProps => {
        if (this.props.openModal !== prevProps.openModal) {
            this.setState({
                uploadsComplete: false,
                error: "",
                open: this.props.openModal,
                status: ""
            })
        }
    }
    handleChangeStatus = ({ meta, remove }, status, fileWithMeta) => {
        if (status === 'done') {          
            let uploadsInProgress = false;
            fileWithMeta.forEach(file => {
                if (file.meta.status !== 'done'){
                    uploadsInProgress = true;
                }            
            });
            if (!uploadsInProgress){
                this.setState({
                    uploadsComplete: true,
                    error: "",
                    status: status,
                    fileWithMeta: fileWithMeta
                });
            }
        }
        else {
            //TODO: display upload error in Modal
            switch (status) {
                case status.indexOf('error' > -1):
                    this.setState({
                        error: `${meta.name}, upload failed. with error: ${status}`,
                        status: status
                    });
                    break;
                case "aborted":
                    this.setState({
                        error: `${meta.name}, upload was aborted.`,
                        status: status
                    });
                    break;
                default:
                    break;
            }
        }
    }
    close = () => {
        //call props function with uploadsComplete and error
        const { closeModal } = this.props
        const { uploadsComplete, error, fileWithMeta } = this.state;
        closeModal(uploadsComplete, error, fileWithMeta);
        this.setState({ open: false });
    }
    render() {
        const { getUploadParams, files } = this.props;
        const { uploadsComplete, error, open } = this.state;

        return (
            <Modal
                closeIcon
                open={open}
                onClose={this.close}
                closeOnDimmerClick={false}
                closeOnEscape={false}
            >
                <Header icon='upload' content='Uploading Assets Please Wait ....' />
                <Modal.Content>
                    <Container
                        id="uploading"
                    >
                        <Dropzone
                            getUploadParams={getUploadParams}
                            onChangeStatus={this.handleChangeStatus}
                            InputComponent={null}
                            initialFiles={files}
                            multiple={true}
                            canCancel={false}
                            canRemove={false}
                            canRestart={false}
                            styles={{
                                dropzone: { border: '2px dashed #eaeaea', overflow: 'scroll' },
                            }}
                        />
                        {uploadsComplete && error === "" && (
                            <Message
                                icon='inbox green'
                                header='All Uploads Complete'
                                content='Click Here to close Window.'
                                onClick={this.close}
                            />
                        )}
                        {error && (
                            <Message
                                icon='warning red'
                                header='Upload Error'
                                content={error}
                                onClick={this.close}
                            />
                        )
                        }
                    </Container>
                </Modal.Content>
            </Modal>
        );
    }
}

export default ModalUpload;
